module.exports = __webpack_public_path__ + "img/baseline-add-24px.940b078b.svg";